export const NONE_VALUE = 'None';
export const PLACEHOLDER_VALUE = '-';
